import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { shouldAttachOverflowTooltip } from '../multiselect-helper.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import { PRODUCT_AREA_COLORS } from '../../../utils/color.js';

var script = {
  name: 'PendoGroupOption',
  components: {
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      showOverflowTooltip: false,
      tooltipTimeout: null
    };
  },
  computed: {
    label() {
      return this.multiselect.getOptionLabel(this.option);
    },
    group() {
      let content = 'No Product Area';
      if (this.option.group && this.option.group.name) {
        content = this.option.group.name;
      }
      return content;
    },
    color() {
      if (this.option.group && this.option.group.color) {
        let {
          color
        } = this.option.group;
        if (color.includes('.')) {
          color = color.substr(1);
        }
        return PRODUCT_AREA_COLORS[color];
      }
      return PRODUCT_AREA_COLORS.groupColorUngrouped;
    },
    icon() {
      return _objectSpread2({
        size: 14
      }, this.option.icon);
    }
  },
  methods: {
    onOptionMouseenter() {
      const showOverflowTooltip = shouldAttachOverflowTooltip(this.label, this.$refs.label);
      if (showOverflowTooltip) {
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = setTimeout(() => {
          this.showOverflowTooltip = true;
        }, 300);
      }
    },
    onOptionMouseleave() {
      clearTimeout(this.tooltipTimeout);
      this.showOverflowTooltip = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-group-option.vue2.js.map
